import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

class Goods extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        pluginData: PropTypes.object,
    };

    render() {
        const { content, pluginData } = this.props;
        const { id = '' } = content;
        const { goodsPlugin = {} } = pluginData;
        const { goods = [] } = goodsPlugin;
        const goodsData = goods.filter(item => item.id === id)[0] || {};

        return goodsData.id ? (
            <div>
                {goodsData.pcUrl ? (
                    <a href={goodsData.pcUrl} target="_blank">
                        <img src={goodsData.pcPic} alt="" />
                    </a>
                ) : (
                    <img src={goodsData.pcPic} />
                )}
            </div>
        ) : null;
    }
}

export default Goods;
